import { createStore, applyMiddleware, compose } from 'redux'
// import { connectRouter, routerMiddleware } from 'connected-react-router'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import rootReducer from 'reducers'

const configureStore = (history) => {
  const middlewares = [routerMiddleware(history), thunk]

  const enhancers = [applyMiddleware(...middlewares)]

  const finalCreateStore = compose(...enhancers)(createStore)
  const store = finalCreateStore(rootReducer)

  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js